import React from 'react';
import { Calendar, Clock, AlertTriangle } from 'react-feather';
import { formatDueDate } from '../../utils/taskUtils';
import './TaskDueDate.css';

const TaskDueDate = ({ dueDate, className = '', taskStatus }) => {
  // Hide due date if task is completed or released
  if (taskStatus && ['completed', 'released'].includes(taskStatus.toLowerCase())) {
    return null;
  }

  const dueDateInfo = dueDate ? formatDueDate(dueDate) : null;

  if (!dueDateInfo) return null;

  const getIcon = () => {
    switch (dueDateInfo.status) {
      case 'overdue':
        return <AlertTriangle size={12} />;
      case 'due-today':
      case 'urgent':
        return <Clock size={12} />;
      case 'upcoming':
      case 'normal':
      default:
        return <Calendar size={12} />;
    }
  };

  return (
    <span className={`task-due-date task-due-date--${dueDateInfo.status} ${className}`}>
      {getIcon()}
      <span>{dueDateInfo.text}</span>
    </span>
  );
};

export default TaskDueDate;

